import { decodeInstruction } from './decoders/index.js';
const KNOWN_PROGRAMS = {
    '11111111111111111111111111111111': 'System Program',
    TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA: 'SPL Token',
    TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb: 'Token-2022',
    ComputeBudget111111111111111111111111111111: 'Compute Budget',
    ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL: 'Associated Token Account',
    metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s: 'Token Metadata',
    JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4: 'Jupiter',
    MAR1zHjTq7ZDqBYl2vSdHrNK2QjHjgqzMhkY3Pzvfhw: 'Marinade',
    jito4BDTWhtkLHwDtYv4uRqJ8VrGXtofEJrPjdj5uoB: 'Jito',
};
function getProgramName(programId) {
    return KNOWN_PROGRAMS[programId] || `${programId.slice(0, 4)}...${programId.slice(-4)}`;
}
function buildParsedInstruction(raw, accountKeys, stackHeight = 1) {
    const r = raw;
    const programId = r.programId ?? accountKeys[r.programIdIndex ?? 0] ?? 'Unknown';
    let accounts;
    if (Array.isArray(r.accounts)) {
        if (typeof r.accounts[0] === 'number') {
            accounts = r.accounts.map((i) => accountKeys[i]);
        }
        else {
            accounts = r.accounts;
        }
    }
    return {
        programId,
        accounts,
        data: r.data,
        parsed: r.parsed,
        stackHeight: r.stackHeight ?? stackHeight,
    };
}
export function buildCpiTree(tx, meta) {
    const accountKeys = resolveAccountKeys(tx, meta);
    const topLevel = tx.message.instructions.map((ix, idx) => buildParsedInstruction({ ...ix, programIdIndex: ix.programIdIndex }, accountKeys, 1));
    // Group inner instructions by parent index
    const innerByParent = new Map();
    if (meta.innerInstructions) {
        for (const group of meta.innerInstructions) {
            innerByParent.set(group.index, group.instructions.map((ix) => buildParsedInstruction(ix, accountKeys, ix.stackHeight ?? 2)));
        }
    }
    // Build nested tree using stackHeight
    const rootNodes = [];
    for (let i = 0; i < topLevel.length; i++) {
        const top = topLevel[i];
        const node = instructionToNode(top, i, 0);
        const inners = innerByParent.get(i) ?? [];
        // Stack-based nesting
        const stack = [node];
        for (const inner of inners) {
            const child = instructionToNode(inner, i, stack.length);
            const targetHeight = inner.stackHeight ?? 2;
            while (stack.length >= targetHeight) {
                stack.pop();
            }
            const parent = stack[stack.length - 1];
            parent.children.push(child);
            stack.push(child);
        }
        rootNodes.push(node);
    }
    return rootNodes;
}
function instructionToNode(ix, topIndex, childIndex) {
    const decoded = decodeInstruction(ix);
    const id = `${topIndex}-${childIndex}`;
    return {
        id,
        index: topIndex,
        programId: ix.programId,
        programName: getProgramName(ix.programId),
        accounts: ix.accounts?.map((pubkey, idx) => ({
            pubkey,
            signer: false,
            writable: false,
        })) ?? [],
        data: ix.data ?? '',
        decodedData: decoded ?? ix.parsed,
        children: [],
        stackHeight: ix.stackHeight ?? 1,
    };
}
function resolveAccountKeys(tx, meta) {
    const keys = [...tx.message.accountKeys];
    if (meta.loadedAddresses) {
        keys.push(...meta.loadedAddresses.writable, ...meta.loadedAddresses.readonly);
    }
    return keys;
}
//# sourceMappingURL=cpi-tree.js.map